import store from '@/store'

/**
 * v-action="'banner:save'" 按钮级权限；无权限则移除节点
 */
export default {
  inserted (el, binding) {
    const code = binding.value
    if (!code) {
      return
    }
    if (!store.getters.hasAction(code)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
